import * as React from 'react';
import { Tabs, Tab, Typography, Box, Select, FormControl, InputLabel, MenuItem, TextField, Grid, Button } from '@mui/material';
import TpIfa from './TpIfa';
import TpIfaDriver from './TpIfaDriver';
import { CustomTabPanel, a11yProps } from './Home'

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
    <Box sx={{ width: '100%' }}>
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={2} sx={{ width: '100%' }} >
          <Grid container item xs={2}>
            <FormControl size="small" fullWidth>
              <InputLabel id="demo-simple-select-label">ログ</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Age"
              >
                <MenuItem value={10}>Ten</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={1}>
            <Button variant="contained" sx={{}}>更新</Button>
          </Grid>
          <Grid container item xs={1}>
            <Button variant="contained" sx={{}}>Open</Button>
          </Grid>
          <Grid container item xs={0.8}>
            <TextField size="small" type="number" id="outlined-basic" variant="outlined" value={'07'} />
          </Grid>
          <Grid container item xs={0.8}>
            <TextField size="small" type="number" id="outlined-basic" variant="outlined" value={'08'} />
          </Grid>
          <Grid container item xs={1}>
            <Button variant="contained" sx={{}}>認証</Button>
          </Grid>
          <Grid container item xs={1.5}>
            <FormControl size="small" fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={0}
              >
                <MenuItem value={0}>Unlock</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={2}>
            <TextField size="small" id="outlined-basic" variant="outlined" />
          </Grid>
        </Grid>

      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="アナログIFA" {...a11yProps(0)} />
          <Tab label="アナログIFAドライバ" {...a11yProps(1)} />
          <Tab label="アナログIFB" {...a11yProps(2)} />
          <Tab label="アナログIFBドライバ" {...a11yProps(2)} />
          <Tab label="アナログIFB-1ドライバ" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <TpIfa />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TpIfaDriver />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        Item Three
      </CustomTabPanel>
      </Box>
      <Box>
        <Grid container spacing={2} sx={{ width: '100%' }} >
          <Grid container item xs={1} sx={{ marginTop: 1 }}>
            <Typography variant="button" display="block" gutterBottom>
              フィルタ
            </Typography>
          </Grid>
          <Grid container item xs={6}>
            <TextField fullWidth size="small" id="outlined-basic" variant="outlined" />
          </Grid>
          <Grid container item xs={0.8}>
            <Button variant="contained" sx={{}}>設定</Button>
          </Grid>
          <Grid container item xs={0.8}>
            <Button variant="contained" sx={{}}>削除</Button>
          </Grid>
          <Grid container item xs={9.5}>
            <TextField disabled fullWidth size="small" id="outlined-basic" variant="outlined" />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}